import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'

const schema = () =>
  z.object({
    type: z
      .string({ required_error: 'Customization type is required' })
      .min(1, 'Customization type is required'),
    enter_url: z
      .string()
      .url('URL need start with https://')
      .refine((url) => url.startsWith('https://'), {
        message: 'URL need start with https://',
      })
      .nullish()
      .optional(),
    custom_page: z.string().optional(),
  })

export type CustomCompletePageModel = z.infer<ReturnType<typeof schema>>

export const useCustomCompletePageForm = () => {
  const customCompletePageFormTypeSchema = schema()
  const { form, rule } = useFormWithZod(customCompletePageFormTypeSchema)
  return { form, rule, schema: customCompletePageFormTypeSchema }
}
